import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Loader from '../components/Loader';
import { FaSave } from 'react-icons/fa';

import { PiDotsThree } from 'react-icons/pi';
import { obscureString } from '../utils/obsureString';
import { formatDateTime } from '../utils/formatDate';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

const UnknownPackages = () => {
  const [packages, setPackages] = useState([]);
  const [modalData, setModalData] = useState(null); // Modal for claiming
  const [deleteId, setDeleteId] = useState(null); // Delete confirmation
  const [enteredTrackingNumber, setEnteredTrackingNumber] = useState(''); // User input for claim
  const  [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  });

  const apiUrl = process.env.REACT_APP_BASE_URL;
  const user = JSON.parse(localStorage.getItem('user'));

  // Fetch packages from the API
  const fetchPackages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/unclaim?page=${currentPage}`);
      if (!response.ok) throw new Error('Failed to fetch packages');
      const data = await response.json();
      console.log(data)
      setPackages(data['data']);
      setMetaData(data['meta']);

      // setMetaData(data['meta']);
    } catch (err) {
      toast.error(err.message || 'Error fetching packages.');
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchPackages();
  // }, [currentPage]);

  // Handle Claim Submission
  const handleClaimSubmit = async (e) => {
    e.preventDefault();
    if (!modalData || enteredTrackingNumber.trim() === '') return;

    if (enteredTrackingNumber === modalData.tracking_number) {
      try {
        const response = await fetch(`${apiUrl}/api/packages/claim/${modalData.tracking_number}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ courier: user?.courier_id }),
        });
        if (!response.ok) throw new Error('Failed to claim the package');
        toast.success('Package claimed successfully!');
        await fetchPackages();
        setModalData(null);
        setEnteredTrackingNumber('');
      } catch (err) {
        toast.error(err.message || 'Error claiming the package.');
      }
    } else {
      toast.error('Entered tracking number does not match. Please try again.');
    }
  };

  // Handle Delete
  const handleDelete = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/unknown-packages/${deleteId}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('Failed to delete the package');
      toast.success('Package deleted successfully!');
      await fetchPackages();
      setDeleteId(null);
    } catch (err) {
      toast.error(err.message || 'Error deleting the package.');
    }
  };

  const sampleData = [
    {
      "package": "Electronics",
      "tracking_number": "XXXXXX1234",
      "account_id": "ACC001",
      "courier_id": "CR001",
      "approved": "2025-02-01T12:30:00Z"
    },
    {
      "package": "Clothing",
      "tracking_number": "XXXXXX5678",
      "account_id": "ACC002",
      "courier_id": "CR002",
      "approved": "--"
    },
    {
      "package": "Books",
      "tracking_number": "XXXXXX9101",
      "account_id": "ACC003",
      "courier_id": "CR003",
      "approved": "2025-01-29T15:20:00Z"
    },
    {
      "package": "Furniture",
      "tracking_number": "XXXXXX1121",
      "account_id": "ACC004",
      "courier_id": "CR004",
      "approved": "--"
    },
    {
      "package": "Kitchenware",
      "tracking_number": "XXXXXX3141",
      "account_id": "ACC005",
      "courier_id": "CR005",
      "approved": "2025-01-27T08:45:00Z"
    },
    {
      "package": "Automotive Parts",
      "tracking_number": "XXXXXX5161",
      "account_id": "ACC006",
      "courier_id": "CR006",
      "approved": "--"
    },
    {
      "package": "Medical Supplies",
      "tracking_number": "XXXXXX7181",
      "account_id": "ACC007",
      "courier_id": "CR007",
      "approved": "2025-01-25T14:10:00Z"
    },
    {
      "package": "Sports Equipment",
      "tracking_number": "XXXXXX9202",
      "account_id": "ACC008",
      "courier_id": "CR008",
      "approved": "--"
    },
    {
      "package": "Home Appliances",
      "tracking_number": "XXXXXX1222",
      "account_id": "ACC009",
      "courier_id": "CR009",
      "approved": "2025-01-23T09:30:00Z"
    },
    {
      "package": "Toys",
      "tracking_number": "XXXXXX3242",
      "account_id": "ACC010",
      "courier_id": "CR010",
      "approved": "--"
    }
  ]
  

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div className="card lg:h-full w-4/5 lg:w-full  p-6 bg-base-100 shadow-xl">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-3xl font-semibold">Unknown Packages</h2>
            {metaData.totalPages > 1 && (
              <div className="join">
                <button
                  className="join-item btn"
                  disabled={metaData.currentPage <= 1}
                  onClick={() => console.log('Go to previous page')}
                >
                  «
                </button>
                <button className="join-item btn">
                  Page {metaData.currentPage} / {metaData.totalPages}
                </button>
                <button
                  className="join-item btn"
                  disabled={metaData.currentPage >= metaData.totalPages}
                  onClick={() => console.log('Go to next page')}
                >
                  »
                </button>
              </div>
            )}
          </div>

          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-2 sm:px-4 py-2">Package</th>
                <th className="border px-2 sm:px-4 py-2">Tracking Number</th>
                <th className="border px-2 sm:px-4 py-2">Account</th>
                <th className="border px-2 sm:px-4 py-2">Courier</th>
                <th className="border px-2 sm:px-4 py-2">Approved</th>
                <th className="border px-2 sm:px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sampleData.length > 0 ? (
                sampleData.map((pkg) => (
                  <tr key={pkg.id} className="hover:bg-slate-200">
                    <td className="border px-2">{pkg.package}</td>
                    <td className="border px-2">{obscureString(pkg.tracking_number)}</td>
                    <td className="border px-2">{pkg.account_id}</td>
                    <td className="border px-2">{pkg.courier_id}</td>
                    <td className="border px-2">
                      {pkg.approved ? pkg.updated_at : '--'}
                    </td>
                    <td className="border px-2">
                      <div className="dropdown">
                        <button
                          className="btn btn-sm btn-secondary flex items-center"
                          tabIndex={0}
                        >
                          <PiDotsThree />
                        </button>
                        <ul
                          className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow"
                          tabIndex={0}
                        >
                          <li>
                            <button onClick={() => setModalData(pkg)}>Claim</button>
                          </li>
                         {user.role == "super-admin" ?  <li>
                            <button
                              className="text-red-500"
                              onClick={() => setDeleteId(pkg.id)}
                            >
                              Delete
                            </button>
                          </li> : null}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No Packages Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Pagination
          currentPage={metaData.currentPage}
          totalPages={metaData.totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
        </div>
      )}

      {/* Claim Modal */}
      {modalData && (
        <dialog className="modal modal-open bg-gray-50">
          <form className="modal-box" onSubmit={handleClaimSubmit}>
            <h3 className="font-bold text-lg">Claim Package</h3>
            <p className="text-sm">
              Enter the tracking number you believe matches the package:
            </p>
            <div className="form-control mt-4">
              <label htmlFor="tracking_number">Tracking Number</label>
              <input
                type="text"
                name="tracking_number"
                value={enteredTrackingNumber}
                onChange={(e) => setEnteredTrackingNumber(e.target.value)}
                className="input input-bordered"
                required
              />
            </div>
            <div className="modal-action">
              <button type="button" className="btn" onClick={() => setModalData(null)}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                <FaSave /> Claim
              </button>
            </div>
          </form>
        </dialog>
      )}

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <dialog className="modal modal-open">
          <div className="modal-box">
            <h3 className="text-lg font-bold">Confirm Deletion</h3>
            <p>Are you sure you want to delete this package?</p>
            <div className="modal-action">
              <button className="btn" onClick={() => setDeleteId(null)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </dialog>
      )}
    </Layout>
  );
};

export default UnknownPackages;
